export default "__VITE_ASSET__BqfggQMp__"